import {Button, Modal} from "antd";
import React from "react";
import FirebaseService from "../../../core/services/firebaseService/firebase.service";
import {UI} from "../../../core/utilities/ui";
import FirebaseKey from "../../FirebaseKey/FirebaseKey";
import "./ContactSuccessModal.scss";

interface IProps {
  callback: () => void;
}

const ContactSuccessModal = (props: IProps) => {
  
  return (
    <Modal
      className="contact-success-modal"
      maskStyle={UI.modalMaskStyle()}
      visible
      closable={false}
      footer={false}
      centered
      destroyOnClose
      onCancel={props.callback}
    >
      <div className="content">
        <FirebaseKey className="title" firebaseKey={FirebaseService.contact_us_successful_title}/>
        <FirebaseKey className="text" firebaseKey={FirebaseService.contact_us_successful_text}/>
        <Button
          className="app-button blue"
          onClick={props.callback}
        >
          <FirebaseKey firebaseKey={FirebaseService.contact_us_successful_button}/>
        </Button>
      </div>
    </Modal>
  );
}

export default ContactSuccessModal;
